<ion-app>
  <!-- Menu Lateral -->
  <ion-menu contentId="main-content">
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>
          <img src="../assets/icon/icone.png" alt="Logo" style="height: 40px; margin-right: 8px;" />
          InnovaTransit
        </ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">

      <!-- ===== MENU DO MOTORISTA ===== -->
      <ion-list *ngIf="isMotorista">
        <ion-item button [routerLink]="['/motorista/folha-servico']" (click)="fecharMenu()">
          Viagens
        </ion-item>
        <ion-item button [routerLink]="['/motorista/exibir-viagens']" (click)="fecharMenu()">
          Comprovante de Registro de Ponto do Trabalhador
        </ion-item>
        <!--<ion-item button [routerLink]="['/motorista/trocar-veiculo']" (click)="fecharMenu()">
          Alterar Veículo
        </ion-item>-->
        <ion-item button [routerLink]="['/motorista/acerto-hora']" (click)="fecharMenu()">
          Corrigir hora
        </ion-item>
        <ion-item button [routerLink]="['/motorista/extrato-horarios']" (click)="fecharMenu()">
          Extrato de Horários por Período
        </ion-item>
        <ion-item button [routerLink]="['/motorista/papeleta-externa']" (click)="fecharMenu()">
          Papeleta Externa
        </ion-item>
        <ion-item button (click)="logout()">
          Sair
        </ion-item>
        <ion-item button (click)="abrirAjudaMotorista()">
          Ajuda
        </ion-item>
      </ion-list>

      <!-- ===== MENU DO GERENTE ===== -->
      <ng-container *ngIf="isGerente">

        <ion-item button [routerLink]="['/gerente/dashboard']" (click)="fecharMenu()">
          Dashboard
        </ion-item>
        <ion-item button (click)="toggleSubmenuApi()" [class.active]="submenuApiAberto">
          Sistema
          <span class="chevron" [class.open]="submenuApiAberto"></span>
        </ion-item>
        <div class="submenu" *ngIf="submenuApiAberto"
          style="margin-left: 5px; border-left: 2px solid #3b82f6; padding-left: 12px;">
          <ion-item button [routerLink]="['/gerente/painel-api-externa']" (click)="fecharMenu()" class="submenu-item">
            Configurações da API
          </ion-item>
          <ion-item button [routerLink]="['/gerente/parametros-empresa']" (click)="fecharMenu()" class="submenu-item">
            Configurações da Empresa
          </ion-item>
          <ion-item button [routerLink]="['/gerente/perfil-usuario']" (click)="fecharMenu()" class="submenu-item">
            Perfil Usuário
          </ion-item>
        </div>

        <!-- Cadastros -->
        <ion-item button (click)="toggleSubmenuCadastros()" [class.active]="submenuCadastrosAberto">
          Cadastros
          <span class="chevron" [class.open]="submenuCadastrosAberto"></span>
        </ion-item>
        <div class="submenu" *ngIf="submenuCadastrosAberto"
          style="margin-left: 5px; border-left: 2px solid #3b82f6; padding-left: 12px;">
          <ion-item button [routerLink]="['/gerente/painel-cadastro-empresa']" (click)="fecharMenu()"
            class="submenu-item">
            Empresa
          </ion-item>
          <ion-item button [routerLink]="['/gerente/painel-cadastro-gerente']" (click)="fecharMenu()"
            class="submenu-item">
            Usuario
          </ion-item>
          <ion-item button [routerLink]="['/gerente/config-email']" (click)="fecharMenu()" class="submenu-item">
            E-mail
          </ion-item>
          <ion-item button [routerLink]="['/gerente/motivo-acerto']" (click)="fecharMenu()" class="submenu-item">
            Motivos de acertos
          </ion-item>
          <ion-item button [routerLink]="['/gerente/cerca-eletronica']" (click)="fecharMenu()" class="submenu-item">
            Cerca Eletronica
          </ion-item>
          <ion-item button [routerLink]="['/gerente/cadastro-obs-mot']" (click)="fecharMenu()" class="submenu-item">
            Observações Motoristas
          </ion-item>
        </div>

        <!-- Operação -->
        <ion-item button (click)="toggleSubmenuOperacao()" [class.active]="submenuOperacaoAberto">
          Operação
          <span class="chevron" [class.open]="submenuOperacaoAberto"></span>
        </ion-item>
        <div class="submenu" *ngIf="submenuOperacaoAberto"
          style="margin-left: 5px; border-left: 2px solid #3b82f6; padding-left: 12px;">
          <ion-item button [routerLink]="['/gerente/operacao-online']" (click)="fecharMenu()" class="submenu-item">
            Gerenciar operações
          </ion-item>
          <ion-item button [routerLink]="['/gerente/editar-papeleta']" (click)="fecharMenu()" class="submenu-item">
            Editar papeleta
          </ion-item>
          <ion-item button [routerLink]="['/gerente/critica']" (click)="fecharMenu()" class="submenu-item">
            Crítica
          </ion-item>
          <ion-item button [routerLink]="['/gerente/resetar-temp-senha']" (click)="fecharMenu()" class="submenu-item">
            Resetar senha padrão
          </ion-item>
        </div>

        <!-- Relatórios -->
        <ion-item button (click)="toggleSubmenuRelatorios()" [class.active]="submenuRelatoriosAberto">
          Relatórios
          <span class="chevron" [class.open]="submenuRelatoriosAberto"></span>
        </ion-item>
        <div class="submenu" *ngIf="submenuRelatoriosAberto"
          style="margin-left: 5px; border-left: 2px solid #3b82f6; padding-left: 12px;">
          <ion-item button [routerLink]="['/gerente/relatorio-periodo']" (click)="fecharMenu()" class="submenu-item">
            Papeletas por período
          </ion-item>
          <ion-item button [routerLink]="['/gerente/relatorio-pdf']" (click)="fecharMenu()" class="submenu-item">
            Papeletas por motorista
          </ion-item>
          <ion-item button [routerLink]="['/gerente/relatorio-verificacao']" (click)="fecharMenu()"
            class="submenu-item">
            Verificações de papeletas
          </ion-item>
          <ion-item button (click)="toggleSubmenuRelatoriosFiscais()" [class.active]="submenuRelatoriosFiscaisAberto">
            Relatórios Fiscais
            <span class="chevron" [class.open]="submenuRelatoriosFiscaisAberto"></span>
          </ion-item>
          <div class="submenu" *ngIf="submenuRelatoriosFiscaisAberto"
            style="margin-left: 5px; border-left: 2px solid #3b82f6; padding-left: 12px;">
            <ion-item button [routerLink]="['/gerente/relatorio-aej']" (click)="fecharMenu()" class="submenu-item">
              Relatório AEJ
            </ion-item>
            <ion-item button [routerLink]="['/gerente/relatorio-afd']" (click)="fecharMenu()" class="submenu-item">
              Relatório AFD
            </ion-item>
          </div>
        </div>

        <ion-item button (click)="toggleSubmenuIntegracao()" [class.active]="submenuIntegracaoAberto">
          Integração
          <span class="chevron" [class.open]="submenuIntegracaoAberto"></span>
        </ion-item>
        <div class="submenu" *ngIf="submenuIntegracaoAberto"
          style="margin-left: 5px; border-left: 2px solid #3b82f6; padding-left: 12px;">
          <ion-item button [routerLink]="['/gerente/corrigir-integracao']" (click)="fecharMenu()" class="submenu-item">
            Integração
          </ion-item>
        </div>


        <!-- Papeleta -->
        <!--<ion-item button (click)="toggleSubmenuPapeleta()" [class.active]="submenuPapeletaAberto">
          Papeleta
          <span class="chevron" [class.open]="submenuPapeletaAberto"></span>
        </ion-item>
        <div class="submenu" *ngIf="submenuPapeletaAberto"
          style="margin-left: 5px; border-left: 2px solid #3b82f6; padding-left: 12px;">
          <ion-item button [routerLink]="['/gerente/editar-papeleta']" (click)="fecharMenu()" class="submenu-item">
            Editar papeleta
          </ion-item>
          <ion-item button [routerLink]="['/gerente/criar-papeleta']" (click)="fecharMenu()" class="submenu-item">
            Nova papeleta
          </ion-item>
        </div>-->

        <!-- Sair (Gerente) -->
        <ion-item button (click)="logoutGerente()">
          Sair
        </ion-item>
        <ion-item button (click)="abrirAjudaRetaguarda()">
          Ajuda
        </ion-item>
      </ng-container>

    </ion-content>
  </ion-menu>

  <!-- Conteúdo Principal -->
  <div class="ion-page" id="main-content">
    <ion-router-outlet></ion-router-outlet>
  </div>
</ion-app>